import axios from '../http'
import {API} from "../const"

const api = API + '/home/content';

const error = (name) => (e) => console.error(name + ':=>', e);

export function listAds(cb, fcb = error('listAds')) {
    axios.get(api).then(d => cb(d.data)).catch(d => fcb(d))
}

export function updatePhonePwd(cb, fcb = error('updatePhonePwd')) {
    axios.get(API + `/users/password/needs-changed`).then(d =>
        cb(d.data)
    ).catch(d => {
        fcb(d)
    })
}

export function determineMobile(newMobile, cb, fcb = error('determineMobile')) {
    axios.get(API + `/users/password/validate-mobile?newMobile=` + newMobile).then(d =>
        cb(d.data)
    ).catch(d => {
        fcb(d)
    })
}

export function getVerificationCodeByMobile(newMobile, cb, fcb = error('getVerificationCodeByMobile')) {
    axios.get(API + `/users/password/code?newMobile=` + newMobile).then(d =>
        cb(d.data)
    ).catch(d => {
        fcb(d)
    })
}

export function submitMobilePwdVer(params, cb, fcb = error('submitMobilePwdVer')) {
    axios.post(API + "/users/password", JSON.stringify(params), {headers: {"Content-Type": "application/json"}}).then(d => {
        cb(d);
    }).catch(err => {
        fcb(err);
    })
}
